class Controller {
  constructor(p) {
    var obj = this;
    var props = [];
    do {
      props = props.concat(Object.getOwnPropertyNames(obj));
    } while (obj = Object.getPrototypeOf(obj));

    /* delete duplate elements: overrided functions appears more than once */
    props = new Set(props);

    for (var key in p) {
      if (props.has(key)) {
        this[key] = p[key];
      }
    }

    this.__sumError  = 0;
    this.__lastError = 0;
    this.__lastTime  = 0;

  }
  set Kp(value) {
    this.__Kp = value;
  }
  get Kp() {
    return this.__Kp;
  }
  set Ki(value) {
    this.__Ki = value;
  }
  get Ki() {
    return this.__Ki;
  }
  set Kd(value) {
    this.__Kd = value;
  }
  get Kd() {
    return this.__Kd;
  }
  set dt(value) {
    this.__dt = value;
  }
  get dt() {
    return this.__dt;
  }
  set Min(value) {
    this.__Min = value;
  }
  get Min() {
    return this.__Min;
  }
  set Max(value) {
    this.__Max = value;
  }
  get Max() {
    return this.__Max;
  }
  set target(value) {
    this.__target = value;
  }
  get target() {
    return this.__target;
  }  
  update(current) {
    let output = 0;
    let error = current - this.target;
    error *= -1;    
  }
}

export default Controller;